import React from "react";

const SvgDomu = props => (
  <svg viewBox="0 0 217 208" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h217v208H0z" />
        <path d="M109.7 7.14c-4.78 0-8.61 3.92-11.52 6.59L22.8 83.06c1.75 4 3.73 8 6 12.23A8.93 8.93 0 0131 96l78.63-73L194 101.27c8.88 8.39 20.76-1.68 10.53-10.9l-83.35-76.64c-2.91-2.67-6.83-6.59-11.48-6.59z" />
        <path d="M109.83 7.14c-4.65 0-8.6 3.92-11.51 6.59L15 90.37c-10.23 9.22 1.66 19.29 10.53 10.9L109.83 23l78.06 72.5c.1-.2.14-.38.24-.58a8 8 0 012.48-4.32 71 71 0 015.77-7.81l-75.07-69.06c-2.91-2.67-6.7-6.59-11.48-6.59z" />
        <path d="M24.78 111.12v69.09c0 8.1 7.68 14.68 17.18 14.68H90.2v-40.73a3.52 3.52 0 013.26-3.74h32.41a3.52 3.52 0 013.26 3.74v40.73h48.23c9.5 0 17.19-6.58 17.19-14.68v-69.09l-84.89-78.29zM49.42 19.14h13.69c3 0 5.49 4.47 5.49 10v19.71c0 5.52-24.68 23.73-24.68 18.21V29.13c0-5.52 0-9.99 5.5-9.99z" />
      </g>
    </g>
  </svg>
);

export default SvgDomu;
